var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 14.6665H4.66675C4.39341 14.6665 4.16675 14.4398 4.16675 14.1665C4.16675 13.8932 4.39341 13.6665 4.66675 13.6665H11.3334C11.6067 13.6665 11.8334 13.8932 11.8334 14.1665C11.8334 14.4398 11.6067 14.6665 11.3334 14.6665Z",
    fill: "url(#paint0_linear_3339_461)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5666 3.67986L10.8999 5.58653C10.5466 5.83986 10.0399 5.68653 9.88657 5.27986L8.62657 1.91986C8.41323 1.33986 7.59324 1.33986 7.3799 1.91986L6.11323 5.2732C5.9599 5.68653 5.4599 5.83986 5.10657 5.57986L2.4399 3.6732C1.90657 3.29986 1.1999 3.82653 1.4199 4.44653L4.19324 12.2132C4.28657 12.4799 4.5399 12.6532 4.8199 12.6532H11.1732C11.4532 12.6532 11.7066 12.4732 11.7999 12.2132L14.5732 4.44653C14.7999 3.82653 14.0932 3.29986 13.5666 3.67986ZM9.66657 9.8332H6.33324C6.0599 9.8332 5.83324 9.60653 5.83324 9.3332C5.83324 9.05986 6.0599 8.8332 6.33324 8.8332H9.66657C9.9399 8.8332 10.1666 9.05986 10.1666 9.3332C10.1666 9.60653 9.9399 9.8332 9.66657 9.8332Z",
    fill: "url(#paint1_linear_3339_461)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3339_461",
    x1: 8.59678,
    y1: 13.8228,
    x2: 8.64403,
    y2: 15.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3339_461",
    x1: 9.02804,
    y1: 3.22992,
    x2: 12.2346,
    y2: 15.6913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.bc8f69e3080ea9179350ede392ab8e5b.svg";
export { ForwardRef as ReactComponent };